import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '../pages/HomePage.vue'
import EventPage from '../pages/EventPage.vue'
import EventWinnerPage from '../pages/EventWinnerPage.vue'
import EventItemQuestionsPage from '../pages/EventItemQuestionsPage.vue'
import EventItemSubmittedPage from '../pages/EventItemSubmittedPage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/events/:eventSlug',
    name: 'event',
    component: EventPage
  },
  {
    path: '/events/:eventSlug/winner',
    name: 'event-winner',
    component: EventWinnerPage
  },
  {
    path: '/events/:eventSlug/items/:itemShortCode',
    name: 'event-item-questions',
    component: EventItemQuestionsPage
  },
  {
    path: '/events/:eventSlug/items/:itemShortCode/submitted',
    name: 'event-item-submitted',
    component: EventItemSubmittedPage
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
